import ICollector from "interfaces/ICollector";
import ICollectorViewModel from "interfaces/ICollectorViewModel";

function getStatusDisplayValue(status: boolean): string {
  return status ? "Active" : "Inactive";
}

function mapCollectorModelToViewModel(
  collector: ICollector
): ICollectorViewModel {
  const collectorViewModel: ICollectorViewModel = {
    id: collector.id,
    statusDisplayValue: getStatusDisplayValue(collector.active),
    name: collector.name,
    type: collector.type,
    isVehicle: collector.isVehicle,
    registration: collector.registration ?? null,
    trackerId: collector.trackingId ?? "",
    userEmailAddress: collector.userEmailAddress,
    active: collector.active,
    notes: collector.notes,
    regions: collector.regions,
    inUse: collector.inUse,
    trackingDeviceName: collector.trackingDeviceName
  };

  return collectorViewModel;
}

export {
  mapCollectorModelToViewModel
};
